import { render, staticRenderFns } from "./FileUploadedScreen.vue?vue&type=template&id=f39833e8&scoped=true"
import script from "./FileUploadedScreen.vue?vue&type=script&lang=js"
export * from "./FileUploadedScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f39833e8",
  null
  
)

export default component.exports